/* this file is generated by merlyn */

// import loading scenes first, get any resources used by them
import { queuedResources } from "$game";
import { DefaultLoader } from "merlyn/loaders";
import { BootLoader } from "merlyn/loaders";
const loaderResources = [...queuedResources];
// end of loading scenes

// import preloaded scenes

// end of preloaded scenes

import * as _game from "../src/game";

export const debug = { show: false, devtool: false };
export const pauseWhenBackgrounded = true;
export const game = _game.default;
export const transition = _game.transition;
export const title = "Night Bike";

export const scenes = {
  boot: "index",
  files: {
    index: () => import("../src/scenes/index.ts"),
  },
};

export const loaders = {
  resources: loaderResources,
  files: {
    default: DefaultLoader,
    boot: BootLoader,
  },
};
